import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormPaymentModule } from 'src/app/shared/form-payment/form-payment.module';
import { TranslateModule } from '@ngx-translate/core';
import { ObserversModule } from '@angular/cdk/observers';
import { FormTestButtonsModule } from 'src/app/shared/form-test-buttons/form-test-buttons.module';
import { FormShippingAddressModule } from 'app/shared/form-shipping-address/form-shipping-address.module';
import { FormStripeCustomerModule } from 'app/shared/form-stripe-customer/form-stripe-customer.module';
import { SectionSummaryItemComponent } from './components/section-summary-item/section-summary-item.component';
import { SectionSummaryComponent } from './components/section-summary/section-summary.component';
import { ToggleCardsItemComponent } from './components/toggle-cards-item/toggle-cards-item.component';
import { ToggleCardsComponent } from './components/toggle-cards/toggle-cards.component';
import { FormShippingMethodComponent } from './components/form-shipping-method/form-shipping-method.component';
import { HeaderComponent } from './components/header/header.component';
import { MainComponent } from './main.component';

@NgModule({
  declarations: [
    MainComponent,
    HeaderComponent,
    FormShippingMethodComponent,
    ToggleCardsComponent,
    ToggleCardsItemComponent,
    SectionSummaryComponent,
    SectionSummaryItemComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    AngularSvgIconModule,
    SharedModule,
    TranslateModule,
    ObserversModule,
    FormTestButtonsModule,
    FormPaymentModule,
    FormShippingAddressModule,
    FormStripeCustomerModule,
  ],
  exports: [MainComponent],
})
export class MainModule {}
